import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
  Spinner,
} from "react-bootstrap";
import Title, {
  SubTitle,
  useScreenSize,
  useCustomScreen,
} from "../../Components/Utils";
import {
  UPDATE_EMAIL,
  BASEURL,
  GetCustomerId,
  GetDecodedToken,
  GetToken,
  GetUserId,
} from "../../CONSTANTS";
import { useNavigate } from "react-router-dom";
import validator from "validator";
import { Loader } from "../../Components/Loader";
import { useAuth } from "../../context/AuthContext";
import Cookies from "js-cookie";
import toast from "react-hot-toast";
import {
  faCircleExclamation,
  faCircleCheck,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const ChangeEmail = () => {
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const [userId, setUserId] = useState("");
  const navigate = useNavigate();
 const { logout } = useAuth();
  const {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isXlScreen,
    isXxlScreen,
    is4kScreen,
  } = useScreenSize();
  const { isIpadProPortrait } = useCustomScreen();

  useEffect(() => {
    getCustomerDetails();
  }, []);

  const getCustomerDetails = async () => {
    try {
      const response = await fetch(`${BASEURL}customers/${GetCustomerId()}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${GetToken()}`,
        },
      });
      const data = await response.json();
     
      setUserDetails(data);
      setUserId(data.email);
      localStorage.setItem("email", data.email)
    } catch (e) {
      console.log("error fetching customer details", e);
    }
  };

  const handlerEMailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    let errorMsg = "";

    if (!value) {
      errorMsg = "Email is required*";
    } else if (!validator.isEmail(value)) {
      errorMsg = "Please enter a valid email address";
    } else {
      errorMsg = "";
    }

    setErrors((prev) => ({ ...prev, email: errorMsg }));
  };

  const saveEmailHandler = async () => {
    if (errors.email || !email) return;

    const data = {
      currentEmail: userId,
      newEmail: email,
    };

    try {
      setLoading(true);
      const response = await fetch(`${UPDATE_EMAIL}`, {
        method: "PUT",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${GetToken()}`,
        },
      });

      if (response.ok) {
        localStorage.setItem("email", userId);
        toast.success("Email update request sent successfully!", {
          icon: (
            <FontAwesomeIcon
              icon={faCircleCheck}
              style={{
                color: "green",
                fontSize: is4kScreen
                  ? "1.9rem"
                  : isXxlScreen
                  ? "1.15rem"
                  : isXlScreen
                  ? "1rem"
                  : isIpadProPortrait
                  ? "1.8rem"
                  : isLargeScreen
                  ? "1rem"
                  : isMediumScreen
                  ? "1.1rem"
                  : "1rem",
              }}
            />
          ),
          style: {
            backgroundColor: "#E7EFC7",
            fontSize: is4kScreen
              ? "1.9rem"
              : isXxlScreen
              ? "1.15rem"
              : isXlScreen
              ? "1rem"
              : isIpadProPortrait
              ? "1.8rem"
              : isLargeScreen
              ? "1rem"
              : isMediumScreen
              ? "1.1rem"
              : "1rem",
            marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
          },
        });
        setEmail("");
        setErrors({});
        logout();
        localStorage.removeItem("email")
        navigate("/login")
      } else {
        const errorText = await response.json();
        
        toast.error(errorText.message || "Failed to update email", {
          icon: (
            <FontAwesomeIcon
              icon={faCircleExclamation}
              style={{
                fontSize: is4kScreen
                  ? "1.9rem"
                  : isXxlScreen
                  ? "1.6rem"
                  : isXlScreen
                  ? "1.5rem"
                  : isIpadProPortrait
                  ? "1.8rem"
                  : isLargeScreen
                  ? "0.9rem"
                  : isMediumScreen
                  ? "1.4rem"
                  : "1rem",
              }}
            />
          ),
          style: {
            backgroundColor: "#FFC1B4",
            color: "red",
            fontSize: is4kScreen
              ? "1.9rem"
              : isXxlScreen
              ? "1.15rem"
              : isXlScreen
              ? "1rem"
              : isIpadProPortrait
              ? "1.8rem"
              : isLargeScreen
              ? "1rem"
              : isMediumScreen
              ? "1.1rem"
              : "1rem",
            marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
          },
        });
      }
    } catch (e) {
      console.log("Error updating email:", e);
      toast.error("Unable to update email. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading ? (
        <Container
          fluid
          className="d-flex justify-content-center align-items-center vh-100"
        >
          <Spinner animation="border" role="status" />
        </Container>
      ) : (
        <Container fluid className="py-4">
          <div>
            <h6
              className="mb-4 text-center text-md-start"
              style={{
                fontSize: is4kScreen
                  ? "1.6rem"
                  : isIpadProPortrait
                  ? "1.6rem"
                  : isMediumScreen
                  ? "1.3rem"
                  : "",
              }}
            >
              <b>Email Address</b>
            </h6>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            className="change-email-cont p-3"
          >
            {/* Current Email */}
            <Row className="mb-3 w-100 align-items-center">
              <Col xs={4} sm={4} className="text-dark text-center text-sm-start">
                <label
                  style={{
                    fontSize: is4kScreen
                      ? "1.7rem"
                      : isIpadProPortrait
                      ? "1.5rem"
                      : isMediumScreen
                      ? "1.2rem"
                      : "",
                  }}
                >
                  Current Email Address:
                </label>
              </Col>
              <Col
                xs={8}
                sm={8}
                className="text-dark text-center text-sm-start"
              >
                <b
                  style={{
                    fontSize: is4kScreen
                      ? "1.7rem"
                      : isIpadProPortrait
                      ? "1.5rem"
                      : isMediumScreen
                      ? "1.2rem"
                      : "",
                  }}
                >
                  {userId}
                </b>
              </Col>
            </Row>

            {/* New Email Input */}
            <Row className="mb-4 w-100 align-items-center">
              <Col xs={12} sm={4} className="text-center text-sm-start mb-2 mb-sm-0">
                <label
                  htmlFor="new-email"
                  style={{
                    fontSize: is4kScreen
                      ? "1.7rem"
                      : isIpadProPortrait
                      ? "1.5rem"
                      : isMediumScreen
                      ? "1.2rem"
                      : "",
                  }}
                >
                  New Email Address:
                </label>
              </Col>
              <Col xs={12} sm={8} className="input-col credits-purchase">
                <input
                  id="new-email"
                  type="email"
                  className="form-control"
                  style={{
                    width: "60%",
                    fontSize: isIpadProPortrait ? "1.5rem" : "",
                    height: isIpadProPortrait ? "3rem" : "",
                  }}
                  value={email}
                  onChange={handlerEMailChange}
                  placeholder="Enter new email"
                />
                {errors.email && (
                  <div className="text-danger" style={{ fontSize: "0.9rem" }}>
                    {errors.email}
                  </div>
                )}
              </Col>
            </Row>

            {/* Save Button */}
            <div className="d-flex justify-content-center">
              <Button
                className="btn login-btns px-4"
                type="button"
                disabled={!!errors.email || !email}
                onClick={saveEmailHandler}
                style={{
                  fontSize: is4kScreen
                    ? "1.7rem"
                    : isIpadProPortrait
                    ? "1.5rem"
                    : isMediumScreen
                    ? "1.3rem"
                    : "",
                  width: is4kScreen
                    ? "10rem"
                    : isIpadProPortrait
                    ? "10rem"
                    : isMediumScreen
                    ? "8rem"
                    : "7rem",
                }}
              >
                <Loader response={loading} action="Save" />
              </Button>
            </div>
          </div>
        </Container>
      )}
    </>
  );
};

const ChangePassword = () => {
  const {
    isSmallScreen,
    isMediumScreen, 
    isLargeScreen,
    isXlScreen,
    isXxlScreen,
    is4kScreen,
  } = useScreenSize();
  const { isIpadProPortrait } = useCustomScreen();
  const navigate = useNavigate();
  const [oldPassword, setOldPassword] = useState("");
  const [mainPassword, setMainPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmError, setConfirmError] = useState("");
  const [loading, setLoading] = useState(false);
  const { logout } = useAuth();

  const esc = encodeURIComponent;

  const tokenFromCookies = Cookies.get("token");
  const decodedToken = Cookies.get("decodedToken");
  const parsedToken = decodedToken ? JSON.parse(decodedToken) : null;
  const customerIdFromCookies = parsedToken ? parsedToken.customerid : null;
  const userIdFromCookies = parsedToken ? parsedToken.unique_name : null;

  const USERID = window.localStorage.getItem("email") || userIdFromCookies;
  const customerId =
    window.localStorage.getItem("customerId") || customerIdFromCookies;
  const TOKEN = window.localStorage.getItem("token") || tokenFromCookies;

  const validatePassword = (password) => {
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumbers = /\d/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
    const isLongEnough = password.length >= 8;

    if (!isLongEnough) return "Password must be at least 8 characters long.";
    if (!hasUpperCase) return "Password must contain at least one uppercase letter.";
    if (!hasLowerCase) return "Password must contain at least one lowercase letter.";
    if (!hasNumbers) return "Password must contain at least one number.";
    if (!hasSpecialChar) return "Password must contain at least one special character.";

    return "";
  };

  const mainPasswordChangeHandler = (e) => {
    const value = e.target.value;
    setMainPassword(value);
    const error = validatePassword(value);
    setPasswordError(error);
    if (confirmPassword && value !== confirmPassword) {
      setConfirmError("Passwords do not match");
    } else {
      setConfirmError("");
    }
  };

  const confirmPasswordChangeHandler = (e) => {
    const value = e.target.value;
    setConfirmPassword(value);
    if (value !== mainPassword) {
      setConfirmError("Confirm password didn't match");
    } else {
      setConfirmError("");
    }
  };

  const oldPasswordChangeHandler = (e) => {
    setOldPassword(e.target.value);
  };

  const changePWD = async () => {
    const url = `${BASEURL}auth/change-password?`;
    const changePswdData = {
      userName: USERID,
      oldPassword,
      newPassword: mainPassword,
      retypeNewPassword: confirmPassword,
    };

    try {
      setLoading(true);
      const query = Object.keys(changePswdData)
        .map((k) => `${esc(k)}=${esc(changePswdData[k])}`)
        .join("&");

      const response = await fetch(`${url}${query}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${TOKEN}`,
        },
        body: JSON.stringify(changePswdData),
      });

      const result = await response.text();

      if (response.ok) {
        toast.success(result || "Password updated successfully!", {
          icon: (
            <FontAwesomeIcon
              icon={faCircleCheck}
              style={{
                color: "green",
                fontSize: is4kScreen
                  ? "1.9rem"
                  : isXxlScreen
                  ? "1.15rem"
                  : isXlScreen
                  ? "1rem"
                  : isIpadProPortrait
                  ? "1.8rem"
                  : isLargeScreen
                  ? "1rem"
                  : isMediumScreen
                  ? "1.1rem"
                  : "1rem",
              }}
            />
          ),
          style: {
            backgroundColor: "#E7EFC7",
            fontSize: is4kScreen
              ? "1.9rem"
              : isXxlScreen
              ? "1.15rem"
              : isXlScreen
              ? "1rem"
              : isIpadProPortrait
              ? "1.8rem"
              : isLargeScreen
              ? "1rem"
              : isMediumScreen
              ? "1.1rem"
              : "1rem",
            marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
          },
        });
        logout();
        localStorage.removeItem("email");  
        navigate("/login");
      } else {
        toast.error(result.message || "Failed to update password", {
          icon: (
            <FontAwesomeIcon
              icon={faCircleExclamation}
              style={{
                fontSize: is4kScreen
                  ? "1.9rem"
                  : isXxlScreen
                  ? "1.6rem"
                  : isXlScreen
                  ? "1.5rem"
                  : isIpadProPortrait
                  ? "1.8rem"
                  : isLargeScreen
                  ? "0.9rem"
                  : isMediumScreen
                  ? "1.4rem"
                  : "1rem",
              }}
            />
          ),
          style: {
            backgroundColor: "#FFC1B4",
            color: "red",
            fontSize: is4kScreen
              ? "1.9rem"
              : isXxlScreen
              ? "1.15rem"
              : isXlScreen
              ? "1rem"
              : isIpadProPortrait
              ? "1.8rem"
              : isLargeScreen
              ? "1rem"
              : isMediumScreen
              ? "1.1rem"
              : "1rem",
            marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
          },
        });
      }
    } catch (e) {
      console.log("Error changing password:", e);
      toast.error("Unable to update password. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const savePassword = () => {
    let hasError = false;

    if (!oldPassword) {
      toast.error("Please enter your current password", {
        icon: <FontAwesomeIcon icon={faCircleExclamation} />,
        style: { backgroundColor: "#FFC1B4", color: "red" },
      });
      hasError = true;
    }

    const passError = validatePassword(mainPassword);
    if (passError) {
      setPasswordError(passError);
      hasError = true;
    }

    if (mainPassword !== confirmPassword) {
      setConfirmError("Confirm password didn't match");
      hasError = true;
    }

    if (!hasError) {
      changePWD();
    }
  };

  const isSaveDisabled =
    !oldPassword ||
    !!passwordError ||
    !!confirmError ||
    !mainPassword ||
    !confirmPassword;

  return (
    <>
      {loading ? (
        <Container
          className="d-flex flex-column justify-content-center align-items-center"
          style={{ height: "100vh" }}
        >
          <Spinner animation="border" role="status" />
        </Container>
      ) : (
        <Container className="py-3">
          <h5
            style={{
              backgroundColor: "lightblue",
              padding: "1em",
              fontSize: is4kScreen
                ? "2rem"
                : isXxlScreen
                ? "1.4rem"
                : isXlScreen
                ? "1.2rem"
                : isIpadProPortrait
                ? "1.95rem"
                : isMediumScreen
                ? "1.7rem"
                : "",
            }}
          >
            <b>Login Settings</b>
          </h5>

          <ChangeEmail />

          <div className="paswd-contnr p-3 mt-4">
            <h6
              style={{
                fontSize: is4kScreen
                  ? "1.6rem"
                  : isIpadProPortrait
                  ? "1.6rem"
                  : isMediumScreen
                  ? "1.3rem"
                  : "",
              }}
            >
              <b>Change Password</b>
            </h6>

            <Container fluid>
              {/* Current Password */}
              <Row className="mb-3" controlId="forOldPassword">
                <Col xs={4} sm={4} className="text-center text-sm-start">
                  <label
                    style={{
                      fontSize: is4kScreen
                        ? "1.7rem"
                        : isIpadProPortrait
                        ? "1.5rem"
                        : isMediumScreen
                        ? "1.2rem"
                        : "",
                    }}
                  >
                    Current Password:
                  </label>
                </Col>
                <Col xs={8} sm={6} className="input-col credits-purchase">
                  <input
                    type="password"
                    className="form-control"
                    style={{
                      width: "80%",
                      fontSize: isIpadProPortrait ? "1.5rem" : "",
                      height: isIpadProPortrait ? "3rem" : "",
                    }}
                    value={oldPassword}
                    onChange={oldPasswordChangeHandler}
                    placeholder="Enter current password"
                  />
                </Col>
              </Row>

              {/* New Password */}
              <Row className="mb-3" controlId="formNewPassword">
                <Col xs={4} sm={4} className="text-center text-sm-start">
                  <label
                    style={{
                      fontSize: is4kScreen
                        ? "1.7rem"
                        : isIpadProPortrait
                        ? "1.5rem"
                        : isMediumScreen
                        ? "1.2rem"
                        : "",
                    }}
                  >
                    New Password:
                  </label>
                </Col>
                <Col xs={8} sm={6} className="input-col credits-purchase">
                  <input
                    type="password"
                    className="form-control"
                    style={{
                      width: "80%",
                      fontSize: isIpadProPortrait ? "1.5rem" : "",
                      height: isIpadProPortrait ? "3rem" : "",
                    }}
                    value={mainPassword}
                    onChange={mainPasswordChangeHandler}
                    placeholder="Enter new password"
                  />
                  {passwordError && (
                    <div className="text-danger" style={{ fontSize: "0.9rem" }}>
                      {passwordError}
                    </div>
                  )}
                </Col>
              </Row>

              {/* Confirm Password */}
              <Row className="mb-3" controlId="formConfirmPassword">
                <Col xs={4} sm={4} className="text-center text-sm-start">
                  <label
                    style={{
                      fontSize: is4kScreen
                        ? "1.7rem"
                        : isIpadProPortrait
                        ? "1.5rem"
                        : isMediumScreen
                        ? "1.2rem"
                        : "",
                    }}
                  >
                    Retype New Password:
                  </label>
                </Col>
                <Col xs={8} sm={6} className="input-col credits-purchase">
                  <input
                    type="password"
                    className="form-control"
                    style={{
                      width: "80%",
                      fontSize: isIpadProPortrait ? "1.5rem" : "",
                      height: isIpadProPortrait ? "3rem" : "",
                    }}
                    value={confirmPassword}
                    onChange={confirmPasswordChangeHandler}
                    placeholder="Re-enter new password"
                  />
                  {confirmError && (
                    <div className="text-danger" style={{ fontSize: "0.9rem" }}>
                      {confirmError}
                    </div>
                  )}
                </Col>
              </Row>

              {/* Save Button */}
              <Row>
                <Col className="d-flex justify-content-center">
                  <Button
                    className="btn login-btns px-4"
                    type="button"
                    disabled={isSaveDisabled}
                    onClick={savePassword}
                    style={{
                      fontSize: is4kScreen
                        ? "1.7rem"
                        : isIpadProPortrait
                        ? "1.5rem"
                        : isMediumScreen
                        ? "1.3rem"
                        : "",
                      width: is4kScreen
                        ? "10rem"
                        : isIpadProPortrait
                        ? "10rem"
                        : isMediumScreen
                        ? "8rem"
                        : "7rem",
                    }}
                  >
                    Save
                  </Button>
                </Col>
              </Row>

              {/* Forgot Password Link */}
              <div className="mt-3">
                <p
                  style={{
                    fontSize: is4kScreen
                      ? "1.7rem"
                      : isIpadProPortrait
                      ? "1.5rem"
                      : isMediumScreen
                      ? "1.2rem"
                      : "",
                    textAlign: isSmallScreen ? "center" : "start",
                  }}
                >
                  If you forget your current password, you can{" "}
                  <a href="/forgot-password">reset it here</a>.
                </p>
              </div>
            </Container>
          </div>
        </Container>
      )}
    </>
  );
};

export default ChangePassword;